module.exports = __webpack_public_path__ + "static/media/cross-country.2fff04d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/cross-country.jpg
// module id = 687
// module chunks = 0